import { render, staticRenderFns } from "./LatestTriggersTable.vue?vue&type=template&id=1349ef78&"
import script from "./LatestTriggersTable.vue?vue&type=script&lang=js&"
export * from "./LatestTriggersTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports